import { apiClient } from '@services/api';

interface InitiateToptanSsoResponse {
  redirectUrl: string;
}

export const ssoService = {
  async initiateToptanSso(): Promise<InitiateToptanSsoResponse> {
    const response = await apiClient.post<InitiateToptanSsoResponse>(
      '/auth/sso/toptan/initiate',
    );
    if (!response.data.success || !response.data.data?.redirectUrl) {
      throw new Error('Toptan geçişi başlatılamadı');
    }
    return response.data.data;
  },
};
